/**
 * THE NEXT STEP (22 Sep) — one strip under the page head that says where the
 * record stands and what a person does next, with the button that does it.
 *
 * The audit of 21 Sep found the flow spread across four screens with no hand
 * from one to the next: an approved order did not say "now prepare a load",
 * a departed truck did not say "now confirm the delivery". Every screen that
 * holds a record in a workflow draws one of these, from the same part, so the
 * hand-over always looks the same.
 */
import * as React from 'react';
import { Button } from './ui.js';
import { go } from './hooks.js';

export function NextStep({ kind = 'info', title, detail, action, secondary }: {
  kind?: 'info' | 'good' | 'warn';
  title: string;
  detail?: string;
  /** the one thing to do next — drawn as the primary button */
  action?: { label: string; href?: string; onClick?: () => void; disabled?: boolean };
  /** a lesser way on, drawn as a plain link */
  secondary?: { label: string; href: string };
}) {
  const mark = kind === 'good' ? '✓' : kind === 'warn' ? '!' : '→';
  return (
    <div className={`banner ${kind} next-step`} role="status">
      <span className="mark" style={{ background: 'currentColor', color: '#fff' }}>{mark}</span>
      <span className="grow">
        {title}
        {detail ? <span className="detail">{detail}</span> : null}
        {secondary ? <span className="detail"><a href={secondary.href} onClick={(e: { preventDefault: () => void }) => { e.preventDefault(); go(secondary.href); }}>{secondary.label} →</a></span> : null}
      </span>
      {action ? (
        <Button kind="primary" small {...(action.disabled ? { disabled: true } : {})}
                onClick={() => { if (action.onClick) action.onClick(); else if (action.href) go(action.href); }}>{action.label}</Button>
      ) : null}
    </div>
  );
}
